import { FilePlus2, Pencil, Send, CheckCircle2, RotateCcw, Copy, Activity } from "lucide-react";
import { format, parseISO } from "date-fns";

const META = {
  created: { label: "Created", Icon: FilePlus2, color: "#C5A880" },
  edited: { label: "Edited", Icon: Pencil, color: "#7DA9D8" },
  sent: { label: "Marked Sent", Icon: Send, color: "#6FA8FF" },
  approved: { label: "Approved", Icon: CheckCircle2, color: "#4ADE80" },
  reopened: { label: "Approval removed", Icon: RotateCcw, color: "#FBBF24" },
  duplicated: { label: "Duplicated", Icon: Copy, color: "#C4A6FF" },
  status_changed: { label: "Status changed", Icon: Activity, color: "#9CA3AF" },
};

const formatWhen = (at) => {
  if (!at) return "";
  try {
    return format(parseISO(at), "d MMM yyyy, h:mm a");
  } catch {
    return at;
  }
};

// Read-only per-quote audit trail (newest first). Manager/Admin only surface.
export default function ActivityTimeline({ activity = [], testId }) {
  const entries = [...activity].reverse();
  if (!entries.length) {
    return (
      <div className="text-[11px] text-white/40" data-testid={testId ? `${testId}-empty` : undefined}>
        No activity yet.
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid={testId}>
      {entries.map((e, i) => {
        const m = META[e.action] || META.status_changed;
        const Icon = m.Icon;
        const key = `${e.at || "na"}-${e.action}-${e.by_user_id || i}`;
        return (
          <div key={key} className="flex items-start gap-2.5" data-testid={testId ? `${testId}-item` : undefined}>
            <div
              className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 mt-0.5"
              style={{ background: `${m.color}1A`, border: `1px solid ${m.color}40` }}
            >
              <Icon size={12} style={{ color: m.color }} />
            </div>
            <div className="min-w-0">
              <div className="text-[12px] text-white/80">
                <span className="font-medium" style={{ color: m.color }}>{m.label}</span>
                {e.by_name ? <span className="text-white/50"> by {e.by_name}</span> : null}
              </div>
              {e.note ? <div className="text-[11px] text-white/40 leading-snug">{e.note}</div> : null}
              <div className="text-[10px] text-white/30 mt-0.5">{formatWhen(e.at)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
